module.exports = ":host{position:relative;display:flex;flex-direction:column}.loader{left:48%;position:absolute;top:-30px;z-index:1}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/data-table-ajax/data-table-ajax.component.scss
// module id = ./src/app/shared/data-table-ajax/data-table-ajax.component.scss
// module chunks = main